import { Component, Inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Producto } from '@p-parametria/mantenimiento/abc-empresas/interfaces/producto';
import { OpcionesRequest } from '@shared/interfaces/request/opciones';
import { CampoTablaWhereService } from '@shared/services/campo-tabla-where.service';
import { OpcionesService } from '@p-p-portafolio/services/opciones.service';
import { ProductosService, IFirmasRequest, IFirmasResponse, IFirmasData, IFirmasDeleteResponse, IOpcionesCutOffResponse, IFirmasAddResponse, IFirmasUpdateResponse } from '@pages/tipos-credito/services/productos.service';
import { InjectableService } from '@shared/utils/injectable.service';
import { SwalService } from '@shared/utils/swal.service';
import { SessionService } from '@shared/helpers/sesion.service';
import { TiposCreditoComponent } from '../tipos-credito.component';
import Swal from 'sweetalert2';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

@Component({
  selector: 'app-tipos-credito-form',
  templateUrl: './tipos-credito-form.component.html',
  styleUrls: ['./tipos-credito-form.component.css'],
})
export class TiposCreditoFormComponent implements OnInit {
  @Input() modelRecived: Producto;
  @Output() onSave = new EventEmitter<void>();
  public loading: boolean;
  public breakpoint: number;
  public empresas: any[];
  public monedas: any[];
  public tiposCredito: any[];
  public sucursales: any[];
  public uso: any[];
  public tiposTasa: any[];
  public opcionesTablaScoring: any[];
  public opcionesFrecuenciaPago: any[];
  public rutasCriticas: any[];

  // Propiedades para el diálogo de Firmas
  public displayFirmasDialog: boolean = false;
  public firmasDataSource: any[] = [];
  public firmasColumns: any[] = [];
  public firmasLoading: boolean = false;

  // Propiedades para el diálogo de Nueva Firma
  public displayNuevaFirmaDialog: boolean = false;
  public nuevaFirmaForm: FormGroup;
  public opcionesCutOff: any[] = [];
  public isSubmittingFirma: boolean = false;
  public isEditMode: boolean = false;
  public firmaEditando: any = null;

  opcionesRequestModel: OpcionesRequest;
  private readonly _width: string = '900px';
  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<TiposCreditoComponent>,
    private _swalService: SwalService,
    private _injectServices: InjectableService,
    private _perfilService: ProductosService,
    private _opcionesService: OpcionesService,
    public _dialog: MatDialog,
    private _ctwServices: CampoTablaWhereService,
    private _sessionService: SessionService,
    @Inject(MAT_DIALOG_DATA) public model: Producto
  ) {}

  ngOnInit(): void {
    this.setForm();
    this.readMonedas();
    this.readEmpresas();
    this.readTiposCredito();
    this.readUso();
    this.readTiposTasa();
    this.readOpcionesTablaScoring();
    this.readOpcionesFrecuenciaPago();
    this.readRutasCriticas();
    this.initializeFirmasColumns();
    this.initializeNuevaFirmaForm();
  }

  form = this._fb.group({
    producto: [''],
    tipoCredito: [''],
    empresa: [''],
    descripcion: [''],
    rutaCriticaAutomatica: [''],
    fechaInicio: [''],
    fechaFin: [''],
    moneda: [''],
    orden: [''],
    tablaScoring: [''],
    tipoTasa: [''],
    plazoMinimo: [''],
    tasaMinima: [''],
    pagoMinimo: [''],
    frecuenciaPago: [''],
    plazoMaximo: [''],
    tasaMaxima: [''],
    precio: [''],
    sucursal: [''],
    tipoGarantia: [''],
    uso: [''],
  });

  formValue(value: string) {
    return this.form.get(value);
  }

  readEmpresas() {
    this._ctwServices.empresas().subscribe((res) => {
      this.empresas = res.data;
    });
  }

  readMonedas() {
    this._ctwServices.monedas().subscribe((res) => {
      this.monedas = res.data;
    });
  }

  readTiposCredito() {
    this.opcionesRequestModel = {
      tabla: 'productos',
      campo: 'tipo_credito',
    };
    this._opcionesService
      .loadCombos(this.opcionesRequestModel)
      .subscribe((res:any) => {
        this.tiposCredito = res.data;
      });
  }

  readTiposTasa() {
    this.opcionesRequestModel = {
      tabla: 'productos',
      campo: 'tipo_tasa',
    };
    this._opcionesService
      .loadCombos(this.opcionesRequestModel)
      .subscribe((res:any) => {
        this.tiposTasa = res.data;
      });
  }

  readUso() {
    this.opcionesRequestModel = {
      tabla: 'productos',
      campo: 'uso',
    };
    this._opcionesService
      .loadCombos(this.opcionesRequestModel)
      .subscribe((res:any) => {
        this.uso = res.data;
      });
  }

  readSucursales(empresa: string) {
    if (empresa) {
      this._ctwServices.sucursales(empresa).subscribe((res) => {
        this.sucursales = res.data;
      });
    }
  }

  readOpcionesTablaScoring() {
    this._perfilService.getOpcionesTablaScoring().subscribe((res: any) => {
      if (res.success) {
        this.opcionesTablaScoring = res.data;
      }
    });
  }

  readOpcionesFrecuenciaPago() {
    this._perfilService.getOpcionesFrecuenciaPago().subscribe((res: any) => {
      if (res.success) {
        this.opcionesFrecuenciaPago = res.data;
      }
    });
  }

  readRutasCriticas() {
    this._perfilService.getRutasCriticas().subscribe((res: any) => {
      if (res.success) {
        this.rutasCriticas = res.data;
      }
    });
  }

  // injectMonedas() {
  //   this._injectServices.disparadorMoneda.subscribe((res) => {
  //     this.form.patchValue({ moneda: res.model.data });
  //     if (res.model.success) this.changeBoolean('form');
  //   });
  // }

  setForm(): void {
    this.modelRecived = this.model;
    if (this.modelRecived) {
      let model: Producto = this.modelRecived;
      const setModel = {
        producto: model.producto?.trim(),
        tipoCredito: model.tipoCredito?.trim(),
        empresa: model.empresa?.trim(),
        descripcion: model.descripcion?.trim(),
        rutaCriticaAutomatica: model.rutaCriticaAutomatica,
        fechaInicio: this.convertDate(model.fechaInicio),
        fechaFin: this.convertDate(model.fechaFin),
        moneda: model.moneda?.trim(),
        orden: model.orden,
        tablaScoring: model.tablaScoring,
        tipoTasa: model.tipoTasa,
        plazoMinimo: model.plazoMinimo,
        tasaMinima: model.tasaMinima,
        pagoMinimo: model.pagoMinimo,
        frecuenciaPago: model.frecuenciaPago?.trim(),
        plazoMaximo: model.plazoMaximo,
        tasaMaxima: model.tasaMaxima,
        precio: model.precio,
        sucursal: model.sucursal,
        tipoGarantia: model.tipoGarantia,
        uso: model.uso,
        user: '',
      };
      this.form.patchValue(setModel);
    } else {
      // Si es un nuevo registro, establecer la fecha actual en formato dd/MM/yyyy
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const year = today.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;
      this.form.patchValue({
        fechaInicio: formattedDate
      });
    }
  }

  private convertDate(dateString: string): string {
    if (!dateString) return '';
    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
  }

  private formatDateForBackend(dateString: string): string {
    if (!dateString) return '';
    // Si la fecha ya está en formato dd/MM/yyyy, retornarla tal cual
    if (dateString.includes('/')) {
      return dateString;
    }
    // Si está en formato yyyy-MM-dd, convertirla
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  }

  create(model: Producto) {
    if (this.form.valid) {
      this.loading = true;
      const formData = {
        ...model,
        plazoMaximo: Number(model.plazoMaximo),
        plazoMinimo: Number(model.plazoMinimo),
        tasaMinima: Number(model.tasaMinima),
        tasaMaxima: Number(model.tasaMaxima),
        pagoMinimo: Number(model.pagoMinimo),
        orden: Number(model.orden),
        fechaInicio: this.formatDateForBackend(model.fechaInicio),
        fechaFin: this.formatDateForBackend(model.fechaFin)
      };
      
      console.log('Valor original de plazoMaximo:', model.plazoMaximo);
      console.log('Valor convertido de plazoMaximo:', formData.plazoMaximo);
      console.log('Tipo de dato de plazoMaximo:', typeof formData.plazoMaximo);
      console.log('Datos completos a enviar:', formData);

      this._perfilService.create(formData).subscribe({
        next: (res) => {
          this.loading = false;
          if (res.exito === 1) {
            this._dialogRef.close();
            this._swalService.success('Agregado');
            this.onSave.emit();
          } else
            this._swalService.error(
              'No Agregado, Puede ser que la clave ya exista, valide con una diferente por favor!'
            );
        },
        error: (error) => {
          console.error('Error en la petición:', error);
          this.loading = false;
        }
      });
    }
  }

  update(model: Producto) {
    if (this.form.valid) {
      this.loading = true;
      const formData = {
        ...model,
        plazoMaximo: Number(model.plazoMaximo),
        plazoMinimo: Number(model.plazoMinimo),
        tasaMinima: Number(model.tasaMinima),
        tasaMaxima: Number(model.tasaMaxima),
        pagoMinimo: Number(model.pagoMinimo),
        orden: Number(model.orden),
        fechaInicio: this.formatDateForBackend(model.fechaInicio),
        fechaFin: this.formatDateForBackend(model.fechaFin)
      };

      console.log('Valor original de plazoMaximo:', model.plazoMaximo);
      console.log('Valor convertido de plazoMaximo:', formData.plazoMaximo);
      console.log('Tipo de dato de plazoMaximo:', typeof formData.plazoMaximo);
      console.log('Datos completos a enviar:', formData);

      this._perfilService.update(formData).subscribe({
        next: (res) => {
          this.loading = false;
          if (res.exito === 1) {
            this._dialogRef.close();
            this._swalService.success('Editado');
            this.onSave.emit();
          } else this._swalService.error('No Editado');
        },
        error: (error) => {
          console.error('Error en la petición:', error);
          this.loading = false;
        }
      });
    }
  }

  /*variableValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const variable = control.value;

      if (!variable) return;

      if (variable < 501 || variable > 600) return { variableValidation: true };

      return null;
    };
  }*/

  /*openProductos() {
    const dialogRef = this._dialog.open(ProductosComponent, {
      width: this._width,
    });
    dialogRef.afterClosed().subscribe((res) => {});
  }

  openActividades() { 
    const dialogRef = this._dialog.open(ActividadesComponent, { 
      width: this._width, 
    }); 
    dialogRef.afterClosed().subscribe((res) => {}); 
  }*/

  /*singleDefinicion(): AsyncValidatorFn {
    return (
      control: AbstractControl
    ): Promise<ValidationErrors> | Observable<any> => {
      if (this.modelRecived) return of(true);
      else {
        return this._rangosService.read().pipe(
          map((res) => {
            if (res.exito === 1) return { singleDefinicion: true };
            return null;
          })
        );
      }
    };
  }*/

  onBreakPonit() {
    this.breakpoint = window.innerWidth <= 200 ? 1 : 2;
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 200 ? 1 : 2;
  }

  close() {
    this._dialogRef.close();
  }

  customizables(): void {
    const dialogRef = this._dialog.open(AbcEmpresasCustomizablesComponent, {
      width: "1000px",
      height: "1000px",
      disableClose: true,
      panelClass: ["custom-dialog-zindex"],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        sTabla: "productos",
        sClave: `${this.modelRecived.producto}`,
        sNombre: this.modelRecived.descripcion,
        sTipo: "Opcion",
      },
    });
  }

  // Métodos para el manejo de Firmas
  private initializeFirmasColumns(): void {
    this.firmasColumns = [
      { field: 'control', header: 'Control' },
      { field: 'tipo', header: 'Tipo' },
      { field: 'cutOff', header: 'Cut Off' },
      { field: 'inferior', header: 'Inferior' },
      { field: 'superior', header: 'Superior' },
      { field: 'requerida', header: 'Requerida' },
      { field: 'actions', header: 'Acciones' }
    ];
  }

  openFirmasDialog(): void {
    this.displayFirmasDialog = true;
    this.loadFirmasData();
  }

  hideFirmasDialog(): void {
    this.displayFirmasDialog = false;
  }

  loadFirmasData(): void {
    this.firmasLoading = true;
    
    const request: IFirmasRequest = {
      sUsuario: this._sessionService.getUserSession(),
      iAccion: 4,
      sProducto: this.modelRecived?.producto || '',
      iodbc: 0,
      sTipo: 'Firmas',
      sSubTipo: '',
      dRango1: 0,
      dRango2: 0,
      sPolitica: '',
      sComentario: '',
      iScore: 0,
      iScoreOm: 0
    };

    this._perfilService.getFirmas(request).subscribe({
      next: (response: IFirmasResponse) => {
        if (response.success && response.data) {
          this.firmasDataSource = response.data.map(item => ({
            control: item.odbc?.toString() || 'N/A',
            tipo: item.tipo || 'N/A',
            cutOff: item.politica || 'N/A',
            inferior: item.rango?.toString() || 'N/A',
            superior: item.rango2?.toString() || 'N/A',
            requerida: item.comentario || 'N/A'
          }));
        } else {
          this.firmasDataSource = [];
          this._swalService.warning('No se encontraron firmas para este producto');
        }
        this.firmasLoading = false;
      },
      error: (error) => {
        console.error('Error al cargar las firmas:', error);
        this.firmasDataSource = [];
        this._swalService.error('Error al cargar las firmas');
        this.firmasLoading = false;
      }
    });
  }

  openNewFirma(): void {
    this.isEditMode = false;
    this.firmaEditando = null;
    this.displayNuevaFirmaDialog = true;
    this.nuevaFirmaForm.reset();
    this.loadOpcionesCutOff();
  }

  verFirma(rowData: any): void {
    this.editarFirma(rowData);
  }

  editarFirma(rowData: any): void {
    this.isEditMode = true;
    this.firmaEditando = rowData;
    this.displayNuevaFirmaDialog = true;
    this.loadOpcionesCutOff();
    
    // Cargar los datos en el formulario
    this.nuevaFirmaForm.patchValue({
      cutOff: rowData.cutOff,
      rangoInferior: rowData.inferior,
      rangoSuperior: rowData.superior,
      firmas: rowData.requerida
    });
  }

  eliminarFirma(rowData: any): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: `Se eliminará la firma N° ${rowData.control}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.firmasLoading = true;
        
        const request: IFirmasRequest = {
          sUsuario: this._sessionService.getUserSession(),
          iAccion: 3,
          sProducto: this.modelRecived?.producto || '',
          iodbc: parseInt(rowData.control) || 0,
          sTipo: 'Firmas',
          sSubTipo: '',
          dRango1: 0,
          dRango2: 0,
          sPolitica: '',
          sComentario: '',
          iScore: 0,
          iScoreOm: 0
        };

        this._perfilService.deleteFirma(request).subscribe({
          next: (response: IFirmasDeleteResponse) => {
            if (response.success && response.data) {
              this._swalService.success('Firma eliminada correctamente');
              this.loadFirmasData(); // Recargar la tabla
            } else {
              this._swalService.error('Error al eliminar la firma');
            }
            this.firmasLoading = false;
          },
          error: (error) => {
            console.error('Error al eliminar la firma:', error);
            this._swalService.error('Error al eliminar la firma');
            this.firmasLoading = false;
          }
        });
      }
    });
  }

  // Métodos para el diálogo de Nueva Firma
  private initializeNuevaFirmaForm(): void {
    this.nuevaFirmaForm = this._fb.group({
      cutOff: ['', [Validators.required]],
      rangoInferior: ['', [Validators.required]],
      rangoSuperior: ['', [Validators.required]],
      firmas: ['', [Validators.required]]
    });
  }

  private loadOpcionesCutOff(): void {
    this._perfilService.getOpcionesCutOff().subscribe({
      next: (response: IOpcionesCutOffResponse) => {
        if (response.success && response.data) {
          this.opcionesCutOff = response.data.map((item) => ({
            valor: item.sValor,
            descripcion: item.sOpcion
          }));
        } else {
          this.opcionesCutOff = [];
          this._swalService.warning('No se pudieron cargar las opciones de CutOff');
        }
      },
      error: (error) => {
        console.error('Error al cargar opciones de CutOff:', error);
        this.opcionesCutOff = [];
        this._swalService.error('Error al cargar las opciones de CutOff');
      }
    });
  }

  hideNuevaFirmaDialog(): void {
    this.displayNuevaFirmaDialog = false;
    this.nuevaFirmaForm.reset();
    this.isSubmittingFirma = false;
    this.isEditMode = false;
    this.firmaEditando = null;
  }

  onSubmitNuevaFirma(): void {
    if (this.nuevaFirmaForm.valid && !this.isSubmittingFirma) {
      this.isSubmittingFirma = true;
      this.firmasLoading = true;
      
      const formValues = this.nuevaFirmaForm.getRawValue();
      const request: IFirmasRequest = {
        sUsuario: this._sessionService.getUserSession(),
        iAccion: this.isEditMode ? 1 : 0, // 0 para crear, 1 para editar según especificación
        sProducto: this.modelRecived?.producto || '',
        iodbc: this.isEditMode ? parseInt(this.firmaEditando.control) : 0,
        sTipo: 'Firmas',
        sSubTipo: '',
        dRango1: parseFloat(formValues.rangoInferior) || 0,
        dRango2: parseFloat(formValues.rangoSuperior) || 0,
        sPolitica: formValues.cutOff,
        sComentario: formValues.firmas,
        iScore: 0,
        iScoreOm: 0
      };

      const serviceCall = this.isEditMode 
        ? this._perfilService.updateFirma(request)
        : this._perfilService.addFirma(request);

      serviceCall.subscribe({
        next: (response: IFirmasAddResponse | IFirmasUpdateResponse) => {
          if (response.success && response.data) {
            const mensaje = this.isEditMode ? 'Firma actualizada correctamente' : 'Firma creada correctamente';
            this._swalService.success(mensaje);
            this.hideNuevaFirmaDialog();
            this.loadFirmasData(); // Recargar la tabla
          } else {
            const mensaje = this.isEditMode ? 'Error al actualizar la firma' : 'Error al crear la firma';
            this._swalService.error(mensaje);
          }
          this.firmasLoading = false;
          this.isSubmittingFirma = false;
        },
        error: (error) => {
          console.error('Error al procesar la firma:', error);
          const mensaje = this.isEditMode ? 'Error al actualizar la firma' : 'Error al crear la firma';
          this._swalService.error(mensaje);
          this.firmasLoading = false;
          this.isSubmittingFirma = false;
        }
      });
    }
  }

  formatNumber(value: string | number): string {
    if (!value && value !== 0) return '';
    
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numValue)) return value.toString();
    
    return new Intl.NumberFormat('es-CO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numValue);
  }
}
